import {
  IonAvatar,
  IonButton,
  IonCheckbox,
  IonHeader,
  IonIcon,
  IonImg,
  IonModal,
  IonRow,
  IonSpinner,
} from "@ionic/react";
import DamageDefault from "../assets/image/damageDefault.png";
import * as d3 from "d3";
import { arrowForward, checkmarkCircleOutline, close } from "ionicons/icons";
import ZoomSvg from "../../assets/svg/zoom.svg";
import TractorLeftSvg from "../../assets/svg/tractorLeft.svg";
import TractorRightSvg from "../../assets/svg/tractorRight.svg";
import TractorFrontSvg from "../../assets/svg/tractorFront.svg";
import { ReactSVG } from "react-svg";

import "./ReportDamageModal.css";
import { useEffect, useState } from "react";
import { svgMapping, tractorMapping } from "../../data/vehicleMapping";
import { damageReportOptions } from "../../data/FormOptions";
import { useGetDamageTypeQuery } from "../../api/damage";
import { useGetVehiclePartQuery } from "../../api/vehicles";
import { VehiclePart } from "../../types/api/vehiclePart.types";
interface Step2Props {
  side: string;
  type: string;
  setStep: (step: number) => void;
  storeDamage: () => void;
  setDamageList: (list: { [index: string]: boolean }) => void;
  damageList: { [index: string]: boolean };
  selectedElement: string;
  vehicleParts: VehiclePart[];
  setImageUrl: (image: string) => void;
  setDescription: (des: string) => void;
  setSelectedElement: (element: string) => void;
  setOpen: (value: boolean) => void;
}

const Step2: React.FC<Step2Props> = ({
  side,
  type,
  setStep,
  selectedElement,
  damageList,
  setDamageList,
  vehicleParts,
  storeDamage,
  setImageUrl,
  setDescription,
  setSelectedElement,
  setOpen,
}) => {
  let currentSvg = svgMapping(side, type);
  const [finishModalIsOpen, setFinishModalIsOpen] = useState(false);
  const [selectAllDocumentDefault, setSelectAllDocumentDefault] =
    useState(false);
  const [storeLoading, setStoreLoading] = useState(false);

  let vehiclePart = vehicleParts?.filter(
    (el) =>
      el.code ===
      (selectedElement
        ? selectedElement
        : side === "Inside"
        ? "cabine"
        : side === "TrailerInside" && type === "Carrier"
        ? "carrierTrailerInside"
        : "trailerInside")
  )?.[0];

  const { data: damagesType, isLoading: damageLoading } = useGetDamageTypeQuery(
    {
      page: "1",
      itemsPerPage: "50",
      vehiclePartId: vehiclePart?.id,
    }
  );

  let damageTypeOptions: { label: string; name: string }[] = [];
  if (!damageLoading) {
    damageTypeOptions =
      damagesType
        ?.filter((el) => el.code.code !== "Others")

        .map((el) => {
          return {
            label: el.title,
            name: el.id,
          };
        }) || [];
    if (vehiclePart?.code.includes("Tire")) {
      damageTypeOptions = damageTypeOptions.filter(
        (el) => el.label === "Abimé" || el.label === "Usé"
      );
    }

    if (vehiclePart?.code.includes("window")) {
      damageTypeOptions = damageTypeOptions.filter(
          (el) => el.label === "Élément cassé"
      );
    }

      if (vehiclePart?.code === 'windshield') {
          damageTypeOptions = damageTypeOptions.filter(
              (el) => el.label === "Élément cassé"
          );
      }

    if (vehiclePart?.code.includes("light")) {
        damageTypeOptions = damageTypeOptions.filter(
          (el) => el.label === "Élément cassé"
        );
    }
  }

  useEffect(() => {
    if (finishModalIsOpen) {
      setTimeout(() => {
        setFinishModalIsOpen(false);
        setImageUrl("");

        setDamageList({});
        setDescription("");
        setSelectedElement("");
        setOpen(false);
        setStep(side === "Inside" || side === "TrailerInside" ? 1 : 0);
      }, 2000);
    }
  }, [finishModalIsOpen]);

  useEffect(() => {
    if (selectAllDocumentDefault) {
      let allDamage: { [index: string]: boolean } = {};
      damageTypeOptions.forEach((el) => {
        allDamage[el.name] = true;
      });
      setDamageList(allDamage);
    } else {
      setDamageList({});
    }
  }, [selectAllDocumentDefault]);

  return (
    <>
      <IonModal
        isOpen={finishModalIsOpen}
        initialBreakpoint={1}
        breakpoints={[0, 1]}
      >
        {" "}
        <div className="ReportDamageModal-step4-end">
          <IonIcon
            src={checkmarkCircleOutline}
            className="ReportDamageModal-step4-end-icon"
          />
          <div className="ReportDamageModal-step4-end-text">
            Merci !<br />
            Le dommage a bien été ajouté
          </div>
        </div>
      </IonModal>
      <IonRow className="ReportDamageModal-step2-title">
        {selectedElement
          ? vehiclePart?.title
          : side === "Inside"
          ? "Cabine"
          : "Intérieur"}
      </IonRow>
      <IonRow className="ion-justify-content-center">
        <div className="ReportDamageModal-zoomedcontainer">
          <ReactSVG
            className="ReportDamageModal-tractor_zoomed"
            src={currentSvg}
            beforeInjection={(svg) => {
              svg.style.width = "100%";
              svg.style.height = "100%";
              svg.style.maxHeight = "150px";
              svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
              svg.removeAttribute("width");
              svg.removeAttribute("height");
            }}
            afterInjection={(svg) => {
              const svgElement = svg as SVGSVGElement;

              if (
                side === "Inside" ||
                side === "TrailerInside" ||
                side === "Document"
              ) {
                let zoom = d3.zoom().on("zoom", (e) => {
                  d3.select(svgElement)
                    .select("g")
                    .attr("transform", e.transform);
                });
                d3.select(svgElement).call(zoom as any);
              } else {
                d3.select(svgElement).selectAll("g").attr("transform", null);

                try {
                  const bbox = svgElement.getBBox();
                  if (selectedElement) {
                    const selectedPaths = d3
                      .select(svgElement)
                      .selectAll("path")
                      .filter(function () {
                        const id = (this as any)?.id?.split("-")[0];
                        return id === selectedElement;
                      });

                    if (selectedPaths.size() > 0) {
                      d3.select(svgElement)
                        .selectAll("path")
                        .style("opacity", "0.3");
                      selectedPaths.style("opacity", "1");

                      const pathBBox = (selectedPaths.node() as any)?.getBBox();

                      const topPadding = pathBBox.height * 0.25;
                      const bottomPadding = pathBBox.height * 0.5;
                      const sidePadding = pathBBox.width * 0.3;

                      const elementViewBox = `
              ${pathBBox.x - sidePadding}
              ${pathBBox.y - topPadding}
              ${pathBBox.width + sidePadding * 2}
              ${pathBBox.height + topPadding + bottomPadding}
            `;
                      svgElement.setAttribute(
                        "viewBox",
                        elementViewBox.replace(/\s+/g, " ").trim()
                      );
                    }
                  } else {
                    const padding = Math.max(bbox.width, bbox.height) * 0.15;
                    const viewBox = `${bbox.x - padding} ${bbox.y - padding} ${
                      bbox.width + padding * 2
                    } ${bbox.height + padding * 2}`;
                    svgElement.setAttribute("viewBox", viewBox);
                  }
                } catch (e) {
                  console.error("Error setting viewBox:", e);
                }
                const zoom = d3
                  .zoom()
                  .scaleExtent([0.1, 10])
                  .on("zoom", (event) => {
                    d3.select(svgElement)
                      .select("g")
                      .attr("transform", event.transform);
                  });

                d3.select(svgElement).call(zoom as any);
              }
            }}
          />
        </div>
      </IonRow>

      <div className="ReportDamageModal-footer">
        <>
          <IonRow className="ReportDamageModal-step2-subtitle">
            {side === "Document"
              ? "  Indiquez le ou les types de dommage"
              : "  Indiquez le type de dommage"}
          </IonRow>
          <div className="ReportDamageModal-checkboxList">
            {side === "Document" ? (
              <div
                className={`ReportDamageModal-checkboxList-item ${
                  selectAllDocumentDefault
                    ? "ReportDamageModal-checkboxList-item_active"
                    : null
                }`}
              >
                {" "}
                <IonCheckbox
                  labelPlacement="end"
                  color={"primary"}
                  onIonChange={(e) =>
                    setSelectAllDocumentDefault(e.detail.checked)
                  }
                >
                  Tous les documents sont{" "}
                  {vehiclePart.code === "tractorMissingDocument" ||
                  vehiclePart.code === "trailerMissingDocument" ||
                  vehiclePart.code === "carrierMissingDocument"
                    ? "manquants"
                    : "endommagés"}
                </IonCheckbox>
              </div>
            ) : null}
            {damageTypeOptions?.map((el) => (
              <div
                className={`ReportDamageModal-checkboxList-item ${
                  damageList[el.name]
                    ? "ReportDamageModal-checkboxList-item_active"
                    : null
                }`}
              >
                {" "}
                <IonCheckbox
                  labelPlacement="end"
                  color={"primary"}
                  checked={damageList[el.name] || false}
                  onIonChange={(e) =>
                    setDamageList({
                      ...damageList,
                      [el.name]: e.detail.checked,
                    })
                  }
                >
                  {el.label}
                </IonCheckbox>
              </div>
            ))}
          </div>
        </>
        {Object.values(damageList).some((value) => value) &&
        side === "Document" &&
        (vehiclePart.code === "tractorMissingDocument" ||
          vehiclePart.code === "trailerMissingDocument") ? (
          <IonButton
            color={"success"}
            expand="block"
            onClick={async () => {
              setStoreLoading(true);
              await storeDamage();
              setStoreLoading(false);
              setFinishModalIsOpen(true);
            }}
            className="ReportDamageModal-button_success"
          >
            Valider le nouveau défaut
            {storeLoading ? (
              <IonSpinner
                name="circular"
                slot="end"
                class="ReportDamageModal-loader"
              ></IonSpinner>
            ) : (
              <IonIcon icon={arrowForward} slot="end" />
            )}
          </IonButton>
        ) : (
          <IonButton
            color={"success"}
            disabled={!Object.values(damageList).some((value) => value)}
            expand="block"
            onClick={() => setStep(2)}
            className="ReportDamageModal-button_success"
          >
            Continuer
            <IonIcon icon={arrowForward} slot="end" />
          </IonButton>
        )}
      </div>
    </>
  );
};

export default Step2;
